<template>
  <form class="form-horizontal">
    <card>
      <div slot="header">
        <h4 class="card-title">{{ crud }} Cliente</h4>
      </div>
      <div>
        <fg-input
          name="email"
          label="e-mail"
          v-validate="modelValidations.name"
          v-model="model.email"
          :error="getError('email')"
        ></fg-input>

        <fg-input name="external_id" label="ID Externo" v-model="model.external_id"></fg-input>

        <fg-input name="nickname" label="Apelido" v-model="model.nickname"></fg-input>

        <fg-input name="first_name" label="Nome" v-model="model.first_name"></fg-input>

        <fg-input name="last_name" label="Sobrenome" v-model="model.last_name"></fg-input>

        <!-- <fg-input
          name="phone_area_code"
          label="Código de Área (DDD)"
          v-model="model.phone_area_code"
        ></fg-input> -->
        <fg-input
          name="name"
          label="Código de Área (DDD)"
        > 
          <el-input
            type="text"
            placeholder="Apenas os numeros"
            v-model="model.phone_area_code"
            maxlength="2"
            show-word-limit
          />
        </fg-input>

        <!-- <fg-input name="phone_number" label="Telefone" v-model="model.phone_number"></fg-input> -->

        <fg-input
          name="name"
          label="Telefone"
        > 
          <el-input
            type="text"
            placeholder="Apenas os numeros"
            v-model="model.phone_number"
            maxlength="10"
            show-word-limit
          />
        </fg-input>

        <!-- <fg-input
          name="identification_type"
          label="Tipo de Documento"
          v-model="model.identification_type"
        ></fg-input> -->
         <fg-input
          name="name"
          label="Tipo de Documento"
        > 
          <el-input
            type="text"
            v-model="model.identification_type"
            maxlength="4"
            show-word-limit
          />
        </fg-input>

        <!-- <fg-input
          name="identification_number"
          label="Número do Documento"
          v-model="model.identification_number"
        ></fg-input> -->
        <fg-input
          name="name"
          label="Número do Documento"
        > 
          <el-input
            type="text"
            placeholder="Apenas os numeros"
            v-model="model.identification_number"
            maxlength="15"
            show-word-limit
          />
        </fg-input>

        <!-- <fg-input name="address_zip_code" label="CEP" v-model="model.address_zip_code"></fg-input> -->
       
        <fg-input
          name="name"
          label="CEP"
        > 
          <el-input
            type="text"
            placeholder="Apenas os numeros"
            v-model="model.address_zip_code"
            maxlength="8"
            show-word-limit
          />
        </fg-input>

        <fg-input name="address_street_name" label="Endereço" v-model="model.address_street_name"></fg-input>

        <fg-input label="Descrição">
          <textarea
            class="form-control"
            v-model="model.description"
            placeholder="Escreva aqui..."
            rows="3"
          ></textarea>
        </fg-input>

        <!-- <div>
          <label>Primeira Compra Aprovada</label>
        </div>
        <el-select
          class="select-default"
          size="large"
          placeholder="Selecione"
          v-model="model.first_approved_sale"
        >
          <el-option
            v-for="option in sales"
            class="select-danger"
            :value="option.id"
            :label="`${localeDate(option.updated)} | ID: ${option.id}`"
            :key="option.id"
          ></el-option>
        </el-select> -->
      </div>
    </card>
    <card>
      <div>
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info btn-wd">Salvar</button>
      </div>
    </card>
  </form>
</template>
<script>
import { Select, Option } from "element-ui";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select
  },
  mounted() {
    // this.$store.dispatch("sales/list")
    if (this.$route.params.id) {
      this.$store.dispatch("customers/get", {id: this.$route.params.id}).then(data => {
        this.model = data
      });
      this.crud = "Editar";
    } else {
      this.crud = "Criar";
    }
  },
  computed: {
    sales() {
      return this.$store.state.sales.sales;
    }
  },
  data() {
    return {
      crud: "Editar",
      model: {
        email: "",
        external_id: "",
        description: "",
        nickname: "",
        first_name: "",
        last_name: "",
        phone_area_code: "",
        phone_number: "",
        identification_type: "",
        identification_number: "",
        address_zip_code: "",
        address_street_name: "",
        description: "",
        first_approved_sale: ""
      },
      modelValidations: {
        name: {
          required: true
        }
      }
    };
  },
  methods: {
    localeDate(date) {
      const d = new Date(date);
      return d.toLocaleString("pt-BR");
    },
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Item Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    notifyError() {
      this.$notify({
        message: "Erro</br>Item não Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (this.model.address_zip_code.length === 9) {
          this.model.address_zip_code = this.model.address_zip_code.replace('-','') 
        }
        if (isValid && this.crud === "Criar") {
          this.$store
            .dispatch("customers/create", { item: this.model })
            .then(data => {
              if (data.id) {
                this.notifySuccess();
                this.$router.push(`/app/sales/customers`);
              } else {
                this.notifyError()
              }
            });
        } else if (isValid && this.crud === "Editar") {
          console.log("customer", this.model);
          this.$store
            .dispatch("customers/update", { item: this.model })
            .then(data => {
              if (data.id) {
                this.notifySuccess();
                this.$router.push(`/app/sales/customers`);
              } else {
                this.notifyError()
              }
            });
        }
      });
    }
  }
};
</script>
<style scoped>
.el-select {
  margin-bottom: 10px;
}
img {
  width: 200px;
}
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
</style>
